import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined';
import { useNavigate } from 'react-router-dom';

function TeacherInfoReport() {
  const location = useLocation();
  const { adminmob, branchId, employeeDetails } = location.state;

  const [teacherAttendance, setTeacherAttendance] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState(new Set());
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const udiseNumber = localStorage.getItem("udiseNumber");
  const [schoolData, setSchoolData] = useState(null);
  const navigate = useNavigate();

  const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');
  
        useEffect(() => {
                   const storedLanguage = localStorage.getItem('language') || 'English';
                   setLanguage(storedLanguage);
                 }, []);
                 const dropdownOptions = [
                  { value: 'education', label: language === "English" ? 'Education' : 'शिक्षण' },
                  { value: 'position', label: language === "English" ? 'Designation' : 'पद' },
                  { value: 'appointment', label: language === "English" ? 'First Appointment' : 'पहिली नेमणूक' },
                  { value: 'payscale', label: language === "English" ? 'Pay Scale' : 'पगार श्रेणी' },
                  { value: 'eligibility', label: language === "English" ? 'Eligibility' : 'पात्रता' },
                  { value: 'manyata', label: language === "English" ? 'Manytecha Prakar' : 'मान्यता प्रकार' },
                  { value: 'basicsalary', label: language === "English" ? 'Current Basic Salary' : 'सध्याचा मूलभूत वेतन' },
                  { value: 'retiredate', label: language === "English" ? 'Retirement Date' : 'सेवानिवृत्तीची तारीख' },
                  { value: 'schoolid', label: language === "English" ? 'School ID' : 'शाळा आयडी' },
                  { value: 'aadharnumber', label: language === "English" ? 'Aadhar Card Number' : 'आधार कार्ड नंबर' },
                  { value: 'pancardnumber', label: language === "English" ? 'Pan Card Number' : 'पॅन कार्ड नंबर' },
                ];

  useEffect(() => {
    const fetchTeacherAttendance = async () => {
      try {
        const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData.json`;
        console.log("teacherurl", url);
  
        const response = await fetch(url);
        const data = await response.json();
  
        if (data) {
          const updatedAttendance = Object.keys(data).map((empMobile) => {
            const attData = data[empMobile]; // Directly access the employee data
            return {
              empMobile,
              EmployeeName: attData?.Name || 'Unknown', // Access Name directly
              MobileNumber: attData?.Mobno || 'Unknown', // Access Mobno directly
              // You can also spread other properties of 'TeacherDetails' if necessary
              ...attData?.TeacherDetails, // Use optional chaining
            };
          });
  
          setTeacherAttendance(updatedAttendance);
        } else {
          console.log("No data found in Firebase");
        }
      } catch (error) {
        console.error("Error fetching data from Firebase:", error);
      }
    };
  
    fetchTeacherAttendance();
  }, [adminmob]);

  useEffect(() => {
    fetchSchoolData();
  }, []);

  const fetchSchoolData = () => {
    const firebaseDatabaseUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/schoolData.json`;
console.log("firebase",firebaseDatabaseUrl);

    fetch(firebaseDatabaseUrl)
      .then(response => response.json())
      .then(data => {
        setSchoolData(data);
      })
      .catch(error => {
        console.error('Error fetching school data from Firebase:', error);
      });
  };


  const handleColumnSelection = (event) => {
    const value = event.target.value;
    console.log("value",value);
    
    setSelectedColumns((prevColumns) => {
      const updatedColumns = new Set(prevColumns);
      if (updatedColumns.has(value)) {
        updatedColumns.delete(value);
      } else {
        updatedColumns.add(value);
      }
      return updatedColumns;
    });
  };

  const handleClose = () => {
    navigate(-1);
  };

  const toggleDropdown = () => {
    setIsDropdownVisible((prevState) => !prevState);
  };

 
  const handlePrint = () => {
    const printContent = document.querySelector('.modal-content');
  
    if (printContent) {
      const cloneContent = printContent.cloneNode(true);
  
      const schoolName = cloneContent.querySelector('p'); 
      console.log("school",schoolName);
      
      const otherDetails = cloneContent.querySelectorAll('p'); 
  console.log("otherdetails",otherDetails);
  
      otherDetails.forEach((p, index) => {
        if (index !== 0) { 
          p.style.fontWeight = 'normal'; 
        }
      });
      
      if (schoolName) {
        schoolName.innerHTML = `<h5 style="font-size: 16px; margin-top: 10px;">${schoolData.schoolName}</h5>`; // Increase the font size and set top margin
      }
      const printWindow = window.open('', '', 'height=600,width=800');
      printWindow.document.write(`
        <html>
          <head>
            <title>Print Modal Content</title>
            <style>
              @page {
                size: landscape;
                margin: 3mm;
              }
              body {
                font-family: Arial, sans-serif;
                margin: 0; /* Remove body margin */
              }
              .modal-content {
                margin: 10px; /* Add margin to the modal content */
              }
              thead {
                            background-color: #F0F0F0; /* Set very light gray background color for <thead> */

              }
                            .print-title{
                            padding: 10px 5px;
                            }
            </style>
          </head>
          <body>
            ${cloneContent.outerHTML} <!-- Include the modified outer HTML of the modal content -->
          </body>
        </html>
      `);
      printWindow.document.close(); 
      printWindow.focus(); // Focus the new window
      printWindow.print(); // Trigger print
      printWindow.close(); // Close the print window after printing
    } else {
      console.error('Print content not found');
    }
  };
  
  return (
    <div className="main-content-of-page">
      <div
        id="print-content"
        style={{
          padding: '10px',
          fontFamily: 'Arial, sans-serif',
          maxWidth: '100%',
        }}
      >
          <div
            style={{
              marginBottom: '20px',
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center'
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span
                onClick={toggleDropdown}
                style={{
                  fontSize: '20px',
                  fontWeight: 'bold',
                  transition: 'background-color 0.3s',
                  marginRight: '10px', 
                  position: 'relative', // Add this line
                  zIndex: 2,
                  backgroundColor:'#2980b9',
                  color: 'white',
                  borderRadius:'6px'
                }}
              >
                <FilterListOutlinedIcon />
              </span>
              {isDropdownVisible && (
                <div
                  style={{
                    marginTop: '10px',
                    border: '1px solid #ddd',
                    padding: '10px',
                    backgroundColor: '#f9f9f9',
                    position: 'absolute',
                    zIndex: 1,
                    borderRadius: '8px', // Add this line to position the dropdown below the icon
                     top: '150px',
                    //  marginBottom:'20px'
                  }}
                >
{dropdownOptions.map((option) => (
  <label key={option.value} style={{ display: 'flex', margin: '8px 0' }}>
    <input
      type="checkbox"
      value={option.value}
      checked={selectedColumns.has(option.value)}
      onChange={handleColumnSelection}
      style={{
        marginRight: '10px',
        width: '20px', // Add this line to set the width of the checkbox
        height: '20px' // Add this line to set the height of the checkbox
      }}
    />
    <span style={{ fontSize: '14px', color: '#34495e' }}>
      {option.label}

    </span>
  </label>
))}
                </div>
              )}

              <button
                className="print-btn"
                onClick={handlePrint}
                style={{
                  padding: '10px 20px',
                  fontSize: '16px',
                  borderRadius: '6px',
                  border: '1px solid #2980b9',
                  backgroundColor: '#2980b9',
                  color: 'white',
                  cursor: 'pointer',
                  marginLeft: '20px',
                  transition: 'background-color 0.3s',
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = '#3498db'}
                onMouseOut={(e) => e.target.style.backgroundColor = '#2980b9'}
              >
                Print
              </button>

              <button
            style={{
              backgroundColor: '#dc3545',
              color: '#fff',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '15px',
              marginLeft: '20px', // Reduce the margin to make the button appear on the same line
              fontWeight: 'bold',
            }}
            onClick={handleClose}
          >
            X
          </button>

            </div>
          </div>

          <div  className="modal-content" 
            style={{
              border: '2px solid black',
              width: 'auto',
              margin: 'auto',
              padding: '30px',
              marginTop: '10px',
            }}
          >
            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',
                marginTop: '10px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                padding: '5px',
              }}
            >
              <thead>
                {schoolData && (
                  <tr>
                    <th
                      colSpan={Array.from(selectedColumns).length + 3}
                      style={{
                        color: 'black',
                        padding: '5px',
                        borderRadius: '10px 10px 0 0',
                        textAlign: 'center',
                        lineHeight: '0.4',
                        border: '1px solid black',
                        fontSize: '13px', paddingTop:'10px',
                      }}
                    >
                      <p>
                        <strong>
                          <h5> {schoolData.schoolName}</h5>
                        </strong>
                      </p>
                      <p>{schoolData.sansthaName}</p>
                      <p>
                        {language === 'English' ? 'Taluka:' : 'तालुका:'} {schoolData.taluka} ,{' '}
                        {language === 'English' ? 'Jilha:' : 'जिल्हा:'} {schoolData.jilha}
                      </p>
                      <p>
                        {language === 'English' ? 'Mobile Number:' : 'मोबाइल नंबर:'}{' '}
                        {schoolData.mobileNumber} ,{' '}
                        {language === 'English' ? 'Email:' : 'ईमेल:'} {schoolData.email}
                      </p>
                      <h1
                      className="print-title"
                        style={{
                          fontSize: '18px',
                          textAlign: 'center',
                          color: 'white',
                          padding: '8px',
                          backgroundColor: 'black',
                          border: '1px solid black',
                          width: '200px',
                          borderRadius: '6px',
                          margin: 'auto',
                        }}
                      >
                      {language === "English" ? "Staff Info Report" : "कर्मचारी माहिती अहवाल"}
                      </h1>
                    </th>
                  </tr>
                )}

                <th
                  style={{
                    border: '1px solid black',
                    padding: '8px',
                    textAlign: 'center',
                    backgroundColor: '#ecf0f1',
                    fontSize: '16px',
                    color: 'black',
                    fontWeight: 'bold',
                  }}
                >
                  {language === "English" ? " Sr.No." : "अनु.क्र."}
                </th>

                <th
                  style={{
                    border: '1px solid black',
                    padding: '12px',
                    textAlign: 'center',
                    backgroundColor: '#ecf0f1',
                    fontSize: '16px',
                    color: 'black',
                    fontWeight: 'bold',
                  }}
                >
                  {language === "English" ? "Staff's Name" : "कर्मचाऱ्याचे नाव"}
                </th>

                <th
                  style={{
                    border: '1px solid black',
                    padding: '12px',
                    textAlign: 'center',
                    backgroundColor: '#ecf0f1',
                    fontSize: '16px',
                    color: 'black',
                    fontWeight: 'bold',
                  }}
                >
                   {language === "English" ? " Mobile Number" : "मोबाईल नंबर"}
                </th>

                {Array.from(selectedColumns).map((column) => (
    <th
      key={column}
      style={{
        border: '1px solid black',
        padding: '12px',
        textAlign: 'center',
        backgroundColor: '#ecf0f1',
        fontSize: '16px',
        color: 'black',
        fontWeight: 'bold',
      }}
    >
      {dropdownOptions.find((option) => option.value === column)?.label || column}
    </th>
                ))}
              </thead>

              <tbody>
  {teacherAttendance.length > 0 ? (
    teacherAttendance.map((attendance, index) => (
      <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#f2f2f2' : 'white' }}>
        <td style={{ border: '1px solid black', padding: '12px', textAlign: 'center', fontSize: '14px' }}>
          {index + 1}
        </td> 
        <td style={{ border: '1px solid black', padding: '12px', textAlign: 'center', fontSize: '14px' }}>
          {attendance.EmployeeName}
        </td>
        <td style={{ border: '1px solid black', padding: '12px', textAlign: 'center', fontSize: '14px' }}>
          {attendance.MobileNumber}
        </td>
        {Array.from(selectedColumns).map((column) => (
          <td
            key={column}
            style={{
              border: '1px solid black',
              padding: '12px',
              textAlign: 'center',
              fontSize: '14px',
            }}
          >
            {attendance[column]}
          </td>
        ))}
        {/* Render additional columns based on selectedColumns */}
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="3" style={{ textAlign: 'center', padding: '12px', fontSize: '16px', color: '#7f8c8d' }}>
        No employee details found.
      </td>
    </tr>
  )}
</tbody>
            </table>
          </div>
       
      </div>
    </div>
  );
}

export default TeacherInfoReport;
